export default {"src":"/_next/static/media/integration-app-logo.8f3cf11e.svg","height":24,"width":37,"blurWidth":0,"blurHeight":0};